export default __webpack_public_path__ + "static/media/puolesta-asiointi-white.e89cac88.svg";